var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('van-swipe',{staticStyle:{"width":"100%"},attrs:{"autoplay":3000}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_c('img',{staticStyle:{"width":"100%","display":"block"},attrs:{"src":image}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6de1a08b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/fields/Swiper.vue
// module id = null
// module chunks = 